






















import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import { UserLeaveRule } from '@/types/user.d';

@Component
export default class UserRulesModal extends Vue {
  private valid: boolean = false;

  get userLeaveRules(): UserLeaveRule[] {
    return this.$store.getters['addEditUser/rules'];
  }

  private closeModal(): void {
    this.valid = false;
    this.$store.dispatch('addEditUser/resetRulesModal');
  }

  get showModal(): boolean {
    return this.$store.getters['addEditUser/showRulesModal'];
  }

}
